// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__27T2E","select":"Header_select__15Q70","clinic":"Header_clinic__392hd"};